<template>
  <Badge class="role-badge" :status="badgeStatus(role)">
    {{ role }}
  </Badge>
</template>

<script setup>
import { Badge } from '@stakeui';

defineProps({
  role: {
    type: String,
    required: true,
  }
})

const badgeStatus = role => {
  if (role === 'admin') {
    return 'danger';
  } else if (role === 'member') {
    return 'info';
  }

  return 'success';
};
</script>

<style scoped>
.role-badge {
  text-transform: capitalize;
}
</style>
